import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { ButtonComponent } from "@shared/controls/button/button.component";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { GroupByOption } from "@models/grid/grid-filter";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";

@Component({
  selector: 'app-group-by-btn',
  standalone: true,
  imports: [
    CheckboxComponent,
    NgbDropdownMenu,
    NgbDropdownToggle,
    NgbDropdown,
    DividerComponent,
    ButtonComponent
  ],
  templateUrl: './group-by-btn.component.html',
  styleUrl: './group-by-btn.component.scss'
})
export class GroupByBtnComponent implements OnInit {
  @Input() groupByOptions: GroupByOption[] = [];
  @Input() isDisabled = false;
  @Output() clearGroupBy = new EventEmitter<boolean>();
  @Output() changeGroupByOption = new EventEmitter<number>();

  selectedGroupByIndex = -1;

  ngOnInit(): void {
    this.groupByOptions.forEach((o, index) => {
      if(o.active) {
        this.selectedGroupByIndex = index;
        this.onChangeGroupByOption(index);
      }
    });
  }

  onClearGroupBy(): void {
    this.clearGroupBy.emit(true);
  }

  onChangeGroupByOption(index: number): void {
    this.selectedGroupByIndex = index;
    this.changeGroupByOption.emit(index);
  }
}
